export enum ChatErrorMessages {
  SendingMessageError = 'Something went wrong while sending message',
  RevoteRequestError = 'Something went wrong while requesting revote',
  VotingError = 'Something went wrong while voting',
}
